export enum InterviewStatus {
  NotStarted = 0,
  DoneWithCorrection = 1,
  Done = 2,
}
